module.exports = __webpack_public_path__ + "assets/img/ec59372afc43812df26a2e5ede5f6ff0.png";